import store from "../index";

const getDefaultAuthUser = () => ({
  id: null,
  email: null,
  username: null,
  customerId: null,
  isVindCustomer: false,
  environmentType: null,
  countOfSasCustomers: 0,
  showAdminPanel: false,
  hasSas: false,
  hasContent: false,
  customerHasSas: false,
  customerHas2FA: false,
  hasCompletedProfileSetup: false,
  sasDefaultPath: null,
  themeType: null,
  isInformedAboutNews: false,
  searchInterest: null,
  hasObRole: false,
  hasMailingRole: false,
  isSuperAdmin: false,
  isFomoUser: false,
  fullName: null,
  redirect: {
    redirectPath: null,
    routeName: null,
  },
  xsrfCookieKey: null,
  usesAIAssistant: null,
  userUsesAIAssistant: null,
  canStartProject: false,
});

const state = () => ({
  authUser: getDefaultAuthUser(),
  isLoggedIn: false,
  // Keep here, out of the authUser, since it doesn't depend on authUser directly
  env: 0,
  // Not related to authUser:
  customer: {
    customerPortalName: "",
    customerPortalSignatureName: "",
    phoneNumber: "",
    emailAddress: "",
    twitterUrl: "",
    facebookUrl: "",
    instagramUrl: "",
    linkedinUrl: "",
    baseUrl: "",
  },
  portalThemeTypes: [],
  searchInterests: [],
  professionTypes: [],
  customerPortalNameNoUpper: "",
  applicationLanguageCode: "",
  sasCustomersOptions: [],
  customerSelectionEnabled: false,
  selectedSasCustomer: null,
  modalErrorMessage: "",
  hasModalError: false,
});

const getters = {
  isLoggedIn: (state) => {
    return state.isLoggedIn;
  },
};

const actions = {};

const mutations = {
  setIsLoggedIn(state, val) {
    state.isLoggedIn = val;
  },
  fillPortalCustomer(state, val) {
    state.customer.customerPortalName = val.customerPortalName;
    state.customerPortalNameNoUpper =
      val.customerPortalName != null && val.customerPortalName.length > 0
        ? val.customerPortalName.charAt(0).toLowerCase() +
          val.customerPortalName.slice(1)
        : "";
    state.customer.customerPortalSignatureName =
      val.customerPortalSignatureName;
    state.customer.emailAddress = val.emailAddress;
    state.customer.phoneNumber = val.phoneNumber;
    state.customer.twitterUrl = val.twitterUrl;
    state.customer.facebookUrl = val.facebookUrl;
    state.customer.instagramUrl = val.instagramUrl;
    state.customer.linkedinUrl = val.linkedinUrl;
    state.customer.baseUrl = val.baseUrl;
    state.customer.endDate = val.endDate;
  },

  setEnvironment(state, val) {
    state.env = val;
  },
  resetModalError(state) {
    state.modalErrorMessage = "";
  },
  enableModalError(state) {
    state.hasModalError = true;
  },
  disableModalError(state) {
    state.hasModalError = false;
  },
  updateModalError(state, message) {
    state.modalErrorMessage = message;
  },
  setPortalThemeTypes(state, val) {
    state.portalThemeTypes = val;
  },
  setSearchInterests(state, val) {
    state.searchInterests = val;
  },
  setProfessionTypes(state, val) {
    state.professionTypes = val;
  },
  setLanguageCode(state, val) {
    state.applicationLanguageCode = val;
  },
  setSasCustomersOptions(state, val) {
    if (state.setSasCustomersOptions && state.sasCustomersOptions.length > 0)
      state.sasCustomersOptions.length = 0;
    state.sasCustomersOptions = val;
  },
  enableCustomerSelection(state) {
    if (
      state.sasCustomersOptions &&
      state.sasCustomersOptions.length > 1 &&
      state.authUser.id !== null
    ) {
      state.customerSelectionEnabled = true;
    }
  },
  disableCustomerSelection(state) {
    state.customerSelectionEnabled = false;
  },
  setSelectedSasCustomer(state, id) {
    state.selectedSasCustomer = id;
  },
  setAuthUser(state, user) {
    if (user) {
      state.authUser.id = user.id;
      state.authUser.email = user.email;
      state.authUser.username = user.username;
      state.authUser.customerId = user.customerId;
      state.authUser.isVindCustomer = user.isVindCustomer;
      state.authUser.environmentType = user.environmentType;
      state.authUser.countOfSasCustomers = user.countOfSasCustomers;
      state.authUser.showAdminPanel = user.showAdminPanel;
      state.authUser.hasSas = user.hasSas;
      state.authUser.hasContent = user.hasContent;
      state.authUser.customerHasSas = user.customerHasSas;
      state.authUser.customerHas2FA = user.customerHas2FA;
      state.authUser.hasCompletedProfileSetup = user.hasCompletedProfileSetup;
      state.authUser.sasDefaultPath = user.sasDefaultPath;
      state.authUser.themeType = user.themeType;
      state.authUser.isInformedAboutNews = user.isInformedAboutNews;
      state.authUser.searchInterest = user.searchInterest;
      state.authUser.hasObRole = user.hasObRole;
      state.authUser.hasMailingRole = user.hasMailingRole;
      state.authUser.isSuperAdmin = user.isSuperAdmin;
      state.authUser.IsFomoUser = user.isFomoUser;
      state.authUser.fullName = user.fullName;
      state.authUser.xsrfCookieKey = user.xsrfCookieKey;
      state.authUser.userUsesAIAssistant = user.userUsesAIAssistant;
      state.authUser.usesAIAssistant = user.usesAIAssistant;
      state.authUser.canStartProject = user.canStartProject;
      localStorage.setItem("xsrf-cookie-key", user.xsrfCookieKey);

      store.commit("user/updateThemeType", user.themeType);
      store.commit("user/updateSearchInterest", user.searchInterest);
      store.commit("user/updateIsInformedAboutNews", user.isInformedAboutNews);

      if (user.redirect) {
        state.authUser.redirect.redirectPath = user.redirect.redirectPath;
        state.authUser.redirect.routeName = user.redirect.routeName;
      }

      store.commit("auth/setEnvironment", user.environmentType);
    } else state.authUser = getDefaultAuthUser();

    state.isLoggedIn = user !== null;
  },
  setAuthUserCompletedProfileSetup(state) {
    state.authUser.hasCompletedProfileSetup = true;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
